const actionsScope = 'dashboard/filter';

export const DASHBOARD_FILTER_TYPES = {
  SET_FILTER: `${actionsScope}/set-filter`,
  ADD_DISPLAYABLE_BY_DEFAULT: `${actionsScope}/add-displayable-by-default`,
};



// WEBPACK FOOTER //
// ./src/redux/dashboard/filter-types.js